import { useTranslations } from "next-intl";

import { Button } from "@/components/ui/button";
import { Tag } from "@/components/ui/tag";

export interface FilterTag {
  label: string;
  onRemove: () => void;
}

interface FilterTagsProps {
  tags: FilterTag[];
  onReset: () => void;
}

export function FilterTags({ tags, onReset }: FilterTagsProps) {
  const t = useTranslations("home");

  if (tags.length === 0) return null;

  return (
    <div className="mb-3 flex flex-wrap items-center gap-2">
      {tags.map((tag, i) => (
        <Tag
          key={i}
          label={tag.label}
          color="Neutral"
          appearance="Soft"
          leftIcon={false}
          showPing={false}
          onRemove={tag.onRemove}
        />
      ))}
      <Button variant="ghost" size="sm" onClick={onReset} className="ml-auto font-semibold">
        {t("tags.reset")}
      </Button>
    </div>
  );
}
